/**
 * IMPORTS
 */
import {gql} from '@apollo/client';


/**
 * EXPORTS
 */

/**
 * I am a mutation to create a tag.
 */
export const CREATE_TAG = gql`
mutation createTag ($name: String!, $company: Int!) {
  createTag(name: $name, company: $company) {
    id
    name
    company
  }
}
`;

/**
 * I am a mutation to update a tag.
 */
export const UPDATE_TAG = gql`
mutation updateTag ($id: Int!, $patch: TagPatch!) {
  updateTag(id: $id, patch: $patch) {
    id
    name
    company
  }
}
`;
